export const ADMIN = 'ADMIN';
export const COMPANY_ADMIN = 'COMPANY_ADMIN';
export const MANAGER = 'MANAGER';
export const TECHNICIAN = 'TECHNICIAN';
export const EXTERNAL_TECHNICIAN = 'EXTERNAL_TECHNICIAN';
export const NORMAL = 'NORMAL';
export const REPORTER = 'REPORTER';

export const ONLY_ADMIN = [ADMIN];
export const ADMIN_OR_COMPANY_ADMIN = [ADMIN, COMPANY_ADMIN];
export const ADMINS_AND_MANAGER = [...ADMIN_OR_COMPANY_ADMIN, MANAGER];
export const ADMINS_MANAGER_AND_TECH = [...ADMINS_AND_MANAGER, TECHNICIAN, EXTERNAL_TECHNICIAN];
export const ALL = [...ADMINS_MANAGER_AND_TECH, NORMAL, REPORTER];

export const isAdmin = (roles) => {
    return ONLY_ADMIN.filter(x => roles.includes(x)).length > 0;
};
